/**
 * アップロードする画像を、今の画像と同じ比率・大きさにそろえる（Issue #959）。比率に合わせて真ん中で切り（足りない向きは切らない）、
 * その大きさに縮めて PNG にする。サーバーの card_illust.fit と同じ切り方。デッキイラストは 500 × 500、スリーブは 743 × 1080
 */
export const DECK_IMAGE_SIZES = { illust: [500, 500], sleeve: [743, 1080] };

/** 切り出す範囲（純関数）: 元の大きさ srcW × srcH から、width:height の比率で真ん中を */
export function coverRect(srcW, srcH, width, height) {
  if (srcW * height > srcH * width) {
    const w = Math.round((srcH * width) / height);
    return { x: Math.floor((srcW - w) / 2), y: 0, w, h: srcH };
  }
  const h = Math.round((srcW * height) / width);
  return { x: 0, y: Math.floor((srcH - h) / 2), w: srcW, h };
}

/** ファイル → width × height の PNG の File（名前の拡張子は .png に） */
export async function fitImageFile(file, width, height) {
  const bitmap = await createImageBitmap(file);
  const r = coverRect(bitmap.width, bitmap.height, width, height);
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(bitmap, r.x, r.y, r.w, r.h, 0, 0, width, height);
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
  return new File([blob], file.name.replace(/\.[^.]+$/, '') + '.png', { type: 'image/png' });
}

/** 中心の点 [fx, fy]（0〜1）を中心に、aspect（横:縦）でいちばん大きい範囲（0〜1。絵からはみ出さないよう寄せる）。Godot の PlayerImages.focus_region と同じ */
export const FOCUS_ASPECT = 1.6;
export function focusRegion(imgW, imgH, [fx, fy], aspect = FOCUS_ASPECT) {
  let w = imgW;
  let h = imgW / aspect;
  if (h > imgH) { h = imgH; w = imgH * aspect; }
  const x = Math.min(Math.max(fx * imgW - w / 2, 0), imgW - w);
  const y = Math.min(Math.max(fy * imgH - h / 2, 0), imgH - h);
  return { x: x / imgW, y: y / imgH, w: w / imgW, h: h / imgH };
}
